﻿export default class EntityFieldsControl {
    constructor(options) {
        // input parameters
        this.entityId = options.entityId;
        this.addFieldButtonItem = options.addFieldButtonItem;
        this.addVirtualFieldButtonItem = options.addVirtualFieldButtonItem;
        this.fieldsFilterItem = options.fieldsFilterItem;
        this.fieldsTreeItem = options.fieldsTreeItem;
        this.fieldsDefinitionItem = options.fieldsDefinitionItem;
        this.fieldsDatabaseWrapper = options.fieldsDatabaseWrapper;
        this.entityLocalization = options.entityLocalization;
        this.generalLocalization = options.generalLocalization;

        /* definition properties */
        this.fieldLabel = 'field-label';
        this.fieldName = 'field-name';
        this.fieldDescription = 'field-description';
        this.fieldLength = 'field-length';
        this.fieldSrid= 'field-srid';
        this.fieldDatatype = 'field-data-type';
        this.fieldNotNull = 'field-not-null';
        this.fieldDataSubtype = 'field-data-sub-type';
        this.fieldSpecialType = 'field-special-type';
        this.fieldMimeType = 'field-mime-type';
        this.fieldFileName = 'field-file-name';
        this.fieldForeignKey = 'field-foreign-key';
        this.fieldCoord = 'field-coord';
        this.fieldAccuracy = 'field-accuracy';
        this.fieldAltitude = 'field-altitude';
        this.fieldGeolocated = 'field-geolocated';
        this.fieldDefValue = 'field-def-value';
        this.fieldDefValueEdit = 'field-def-value-edit';
        this.fieldDefValueType = 'field-def-value-type';
        this.fieldDefValueValue = 'field-def-value-value';
        this.fieldDefValueToken = 'field-def-value-token';
        this.fieldDefValueSql = 'field-def-value-sql';
        this.fieldApplyTo = 'field-apply-to';
        this.fieldStoreFilePath = 'field-store-file-path';
        this.fieldAcceptMimeType = 'field-accept-mime-type';
        this.fieldMaxFileSize = 'field-max-file-size';

        /* control properties */
        this.fieldsDatabaseItem = 'database-fields-item';
        this.specialFieldsItem = 'special-fields-item';
        this.geolocatedFieldsItem = 'geolocated-fields-item';
        this.isTreeInitialized = false;
        this.realFields = [];
        this._initControl();

        /* current selection properties */
        this.specialOptions = [];
        this.subTypeOptions = [];
        this.selectedField = null;
        this.selectedFieldShown = false;
    }

    /* Public Methods */
    saveFields() {
        let fields = this._getCurrentFields();

        let data = {
            fields: fields,
            id: this.entityId
        }

        let saveFieldsUrl = rootUrl + 'Entity/SaveFields'

        $.ajax({
            type: "POST",
            url: saveFieldsUrl,
            async: true,
            data: JSON.stringify(data),
            contentType: "application/json; charset=utf-8",
            success: (result) => {
                if (result.jsonEntity != null) {
                    let serializedFields = JSON.parse(result.jsonEntity);
                    this.refreshControl(serializedFields);
                }
            },
            error: (e) => {
                toastr.error(this._getEntityResource('SaveError'));
            }
        });
    }

    refreshControl(fields) {
        let currentFields = [];
        if (fields != null) {
            currentFields = fields;
        } else {
            currentFields = this._getCurrentFields();
        }
        
        this.isTreeInitialized = false;
        this.realFields = [];
        this.specialOptions = [];
        this.subTypeOptions = [];
        this.selectedField = null;
        this.selectedFieldShown = false;
        $('#' + this.fieldsTreeItem).data('kendoTreeView').destroy()
        $('#' + this.fieldsTreeItem)[0].innerHTML = "";
        $('#' + this.fieldsDefinitionItem)[0].innerHTML = "";

        this._loadFieldsTreeDataSource(currentFields);
    }

    /* Private Methods */
    /* Controls */
    _getCurrentFields() {
        this._saveFieldDetails();
        let fields = [];

        let nodes = $('#' + this.fieldsTreeItem).data('kendoTreeView').dataSource.data();
        let index = 0;

        nodes.forEach(node => {
            let field = node.storedItem;
            field.OrderNo = ++index;
            field.IdEntity = this.entityId;
            field.Virtual = node.virtual;
            field.Checked = true;
            fields.push(field);
        });

        return fields;
    }

    _saveFieldDetails() {
        if (this.selectedField != null) {
            let newItem = {};

            this.selectedField.storedItem.Checked = true;
            newItem.DbDataType = this.selectedField.storedItem.DbDataType;
            newItem.DbNotNull = this.selectedField.storedItem.DbNotNull;
            newItem.FieldName = this.selectedField.storedItem.FieldName;

            this.selectedField.storedItem.Description = $('#' + this.fieldDescription).val();
            this.selectedField.storedItem.DataType = $('#' + this.fieldDatatype).data('kendoComboBox').value();
            this.selectedField.storedItem.NotNull = $('#' + this.fieldNotNull).data('kendoSwitch').check();

            if (this.selectedField.storedItem.DataType != null && this.selectedField.storedItem.DataType != '') {
                switch (this.selectedField.storedItem.DataType) {
                    case "STRING": this._saveStringFieldDetails(this.selectedField.storedItem);
                        break;
                    case "INTEGER": this._saveIntegerFieldDetails(this.selectedField.storedItem);
                        break;
                    case "GEOMETRY": this._saveGeometryFieldDetails(this.selectedField.storedItem);
                        break;
                    case "BYTEA": this._saveByteaFieldDetails(this.selectedField.storedItem);
                        break;
                    default: break;
                }
            }
        }
    }

    _saveStringFieldDetails(item) {
        item.Length = $('#' + this.fieldLength).val();

        let checkedSpecialOptions = $('.special-option-choice[checked="checked"]');

        if (checkedSpecialOptions.length > 0) {
            let id = checkedSpecialOptions.attr('id').replaceAll('special-option-choice-', '');

            item.SpecialFieldType = id;
        } else {
            item.SpecialFieldType = null;
        }

        let checkedSubtypeOptions = $('.subtype-option-choice[checked="checked"]');

        if (checkedSubtypeOptions.length > 0) {
            let id = checkedSubtypeOptions.attr('id').replaceAll('subtype-option-choice-', '');

            item.DataSubType = id;
        } else {
            item.DataSubType = null;
        }

        if (item.DataSubType == 'FOREIGN_KEY') {
            let foreignEntity = $('#' + this.fieldForeignKey).data('kendoComboBox').value();

            if (foreignEntity != null && foreignEntity.trim != '') {
                item.IdEntityFK = new Number(foreignEntity);
            }
        }

        if (item.DataSubType == 'FILE') {
            item.MimeTypeFieldName = $('#' + this.fieldMimeType).val();
            item.FileNameFieldName = $('#' + this.fieldFileName).val();
            item.AcceptMimeType = $('#' + this.fieldAcceptMimeType).val();
            item.MaxFileSize = $('#' + this.fieldMaxFileSize).val();
            item.StoreFilePath = $('#' + this.fieldStoreFilePath).val();
            item.Geolocated = $('#' + this.fieldGeolocated).data('kendoSwitch').check();
            item.CoordFieldName = $('#' + this.fieldCoord).val();
            item.AccuracyFieldName = $('#' + this.fieldAccuracy).val();
            item.AltitudeFieldName = $('#' + this.fieldAltitude).val();
            item.Srid = $('#' + this.fieldSrid).data('kendoComboBox').value();
        }
    }

    _saveIntegerFieldDetails(item) {
        let checkedSpecialOptions = $('.special-option-choice[checked="checked"]');

        if (checkedSpecialOptions.length > 0) {
            let id = checkedSpecialOptions.attr('id').replaceAll('special-option-choice-', '');

            item.SpecialFieldType = id;
        } else {
            item.SpecialFieldType = null;
        }

        let checkedSubtypeOptions = $('.subtype-option-choice[checked="checked"]');

        if (checkedSubtypeOptions.length > 0) {
            let id = checkedSubtypeOptions.attr('id').replaceAll('subtype-option-choice-', '');

            item.DataSubType = id;
        } else {
            item.DataSubType = null;
        }

        if (item.DataSubType == 'FOREIGN_KEY') {
            let foreignEntity = $('#' + this.fieldForeignKey).data('kendoComboBox').value();

            if (foreignEntity != null && foreignEntity.trim != '') {
                item.IdEntityFK = new Number(foreignEntity);
            }
        }
    }

    _saveGeometryFieldDetails(item) {
        item.Srid = $('#' + this.fieldSrid).data('kendoComboBox').value();
        item.AccuracyFieldName = $('#' + this.fieldAccuracy).val();
        item.AltitudeFieldName = $('#' + this.fieldAltitude).val();

        let checkedSpecialOptions = $('.special-option-choice[checked="checked"]');

        if (checkedSpecialOptions.length > 0) {
            let id = checkedSpecialOptions.attr('id').replaceAll('special-option-choice-', '');

            item.SpecialFieldType = id;
        } else {
            item.SpecialFieldType = null;
        }

        let checkedSubtypeOptions = $('.subtype-option-choice[checked="checked"]');

        if (checkedSubtypeOptions.length > 0) {
            let id = checkedSubtypeOptions.attr('id').replaceAll('subtype-option-choice-', '');

            item.DataSubType = id;
        }
    }

    _saveByteaFieldDetails(item) {
        let checkedSpecialOptions = $('.special-option-choice[checked="checked"]');

        if (checkedSpecialOptions.length > 0) {
            let id = checkedSpecialOptions.attr('id').replaceAll('special-option-choice-', '');

            item.SpecialFieldType = id;
        } else {
            item.SpecialFieldType = null;
        }

        let checkedSubtypeOptions = $('.subtype-option-choice[checked="checked"]');

        if (checkedSubtypeOptions.length > 0) {
            let id = checkedSubtypeOptions.attr('id').replaceAll('subtype-option-choice-', '');

            item.DataSubType = id;
        }

        item.MimeTypeFieldName = $('#' + this.fieldMimeType).val();
        item.FileNameFieldName = $('#' + this.fieldFileName).val();
        item.AcceptMimeType = $('#' + this.fieldAcceptMimeType).val();
        item.MaxFileSize = $('#' + this.fieldMaxFileSize).val();
        item.Geolocated = $('#' + this.fieldGeolocated).data('kendoSwitch').check();
        item.CoordFieldName = $('#' + this.fieldCoord).val();
        item.AccuracyFieldName = $('#' + this.fieldAccuracy).val();
        item.AltitudeFieldName = $('#' + this.fieldAltitude).val();
        item.Srid = $('#' + this.fieldSrid).data('kendoComboBox').value();
    }

    _initControl() {
        this._loadFieldsTreeDataSource(null);
        this._initEvents();
    }

    _loadFieldsTreeDataSource(fields) {
        let getAllFieldsUrl = rootUrl + "Entity/GetAllFields";
        let data = {
            id: this.entityId
        };

        if (fields != null && fields.length > 0) {
            data.fields = fields;
        }

        $.ajax({
            type: "POST",
            url: getAllFieldsUrl,
            async: true,
            data: JSON.stringify(data),
            contentType: "application/json; charset=utf-8",
            success: (result) => {
                if (result != null && (result.Error == null || result.Error == '')) {
                    let fieldsContainer = JSON.parse(result.jsonEntity);
                    this._handleEntityValidityMessage(fieldsContainer.InvalidProperties);
                    let fields = fieldsContainer.Fields;
                    let dataSource = this._createFieldsDataSource(fields);
                    this._initTree(dataSource);
                } else if (result == null || result.Error == null) {
                    toastr.error(this._getEntityResource('GetAllFieldsError'));
                } else {
                    toastr.error(result.Error);
                }
            },
            error: (e) => {
                toastr.error(this._getEntityResource('GetAllFieldsError'));
            }
        });
    }

    _handleEntityValidityMessage(invalidProperties) {
        if (invalidProperties != null & invalidProperties.length > 0) {
            let errorTemplate = '';
            invalidProperties.forEach(invalidProperty => {
                errorTemplate += '&#9632;' + (invalidProperty.PropertyName != null && invalidProperty.PropertyName != '' ? ('<strong>' + invalidProperty.PropertyName + ':</strong>' + ' ') : '') + ' ' + invalidProperty.Message + '<br>';

            });
            $('#entity-errors-container')[0].innerHTML = errorTemplate;
            $('#entity-validation-wrapper').show();
        } else {
            $('#entity-validation-wrapper').hide();
        }
    }

    _createFieldsDataSource(fields) {
        this.realFields = fields.filter(field => { return field.Virtual == false }).sort((a, b) => { return a.OrderNo - b.OrderNo });

        let mappedFields = fields.filter(field => { return field.Checked == true || field.Virtual == true }).sort((a, b) => { return a.OrderNo - b.OrderNo });

        let treeFields = [];

        let index = 0;

        index = this._storeTreeFields(treeFields, mappedFields, index);

        return new kendo.data.HierarchicalDataSource({
            data: treeFields, schema: {
                model: {
                    id: "index",
                    children: "items"
                }
            }
        });
    }

    _storeTreeFields(storage, fields, index) {
        fields.forEach(field => {
            storage.push({
                storedItem: field,
                index: ++index,
                displayText: field.FieldName,
                virtual: field.Virtual,
                items: []
            });
        });

        return index;
    }

    _initTree(dataSource) {
        if (!this.isTreeInitialized) {
            this.isTreeInitialized = true;

            $('#tabLayoutSel').removeClass('fields-tab-error');

            $('#' + this.fieldsTreeItem).kendoTreeView({
                template: (evt) => {
                    let item = evt.item;
                    let templ = '';
                    if (item.storedItem.InvalidProperties != null && item.storedItem.InvalidProperties.length > 0) {
                        let errorTitle = '';
                        $('#tabLayoutSel').addClass('fields-tab-error');
                        item.storedItem.InvalidProperties.forEach(error => {
                            errorTitle += error.Message + '\n';
                        });

                        templ += '<div title="' + errorTitle + '"><span class="error-tree-node">' + item.displayText + '<i class="ml-2 fal fa-exclamation-circle" style="font-weight: bold;"></i></span></div>';
                    } else if (item.virtual) {
                        templ += '<div><span class="virtual-tree-node">' + item.displayText + '</span></div>';
                    } else {
                        templ += '<div><span class="real-tree-node">' + item.displayText + '</span></div>';
                    }
                    templ += '<div data-handle="' + item.displayText + '" class="fal fa-trash-alt tree-item-remove" onclick="fieldsControl._removeTreeItem(event, this)" style="line-height: 1.2rem; right: 0.4rem; position: absolute;width: 1.2rem; text-align: center;"></div>';
                    return templ;
                },
                dragAndDrop: true,
                dragend: (e) => {
                    this._filterTree();
                },
                loadOnDemand: false,
                dataSource: dataSource,
                dataTextField: "displayText",
                dataValueField: "index",
                select: (e) => {
                    this._selectField(e);
                }
            });

            this._filterTree();
        }
    }

    _removeTreeItem(evt, element) {
        evt.stopPropagation();
        let selection = $(element).closest('[role="treeitem"]');
        let entityFieldCheckIfUsedUrl = rootUrl + "Entity/EntityFieldCheckIfUsed?id=" + $('#' + this.fieldsTreeItem).data('kendoTreeView').dataItem(selection).storedItem.Id;
        if ($('#' + this.fieldsTreeItem).data('kendoTreeView').dataItem(selection).storedItem.Id != 0) {
            $.ajax({
                type: "GET",
                url: entityFieldCheckIfUsedUrl,
                async: true,
                dataType: 'json',
                contentType: "application/json",
                success: (result) => {
                    if (result.jsonEntity != null) {
                        let res = JSON.parse(result.jsonEntity);
                        if (!res) {
                            $('#' + this.fieldsTreeItem).data('kendoTreeView').remove(selection);
                            this._destroyFieldDetails();
                        }
                    }
                },
                error: (e) => {
                    toastr.error(this._getEntityResource('SaveError'));
                }
            });
        } else {
            $('#' + this.fieldsTreeItem).data('kendoTreeView').remove(selection);
            this._destroyFieldDetails();
        }
    }

    _destroyFieldDetails() {
        this._saveFieldDetails();
        this.selectedField = null;
        $('#' + this.fieldsDefinitionItem)[0].innerHTML = '';
    }

    _filterTree() {
        let searchFilter = {
            field: "displayText",
            operator: "contains",
            value: $('#' + this.fieldsFilterItem).val()
        };

        $('#' + this.fieldsTreeItem).data("kendoTreeView").dataSource.filter(searchFilter);
    }

    _selectField(item) {
        $('#' + this.fieldsTreeItem).focus();
        this._selectNode(item.node);
    }

    _selectNode(node) {
        this._saveFieldDetails();
        let selectedItem = $('#' + this.fieldsTreeItem).data("kendoTreeView").dataItem(node);
        this.selectedField = selectedItem;
        this.selectedFieldShown = false;
        $('#' + this.fieldsDefinitionItem)[0].innerHTML = this._getFieldDefinitionTemplate();

        $('#' + this.fieldLabel)[0].innerHTML = selectedItem.storedItem.FieldName;
        $('#' + this.fieldName).val(selectedItem.storedItem.FieldName);
        $('#' + this.fieldDescription).val(selectedItem.storedItem.Description);

        $('#' + this.fieldDatatype).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'Entity/GetFieldDataType';
                        }
                    }
                }
            },
            dataBound: (e) => {
                if (!selectedItem.virtual) {
                    if (selectedItem.storedItem.DataType != null && selectedItem.storedItem.DataType != '' &&
                        (selectedItem.storedItem.DbDataType == null || selectedItem.storedItem.DbDataType == "" || selectedItem.storedItem.DataType == selectedItem.storedItem.DbDataType) && selectedItem.storedItem.DataType != 'INTEGER') {
                        $('#' + this.fieldDatatype).data('kendoComboBox').value(selectedItem.storedItem.DataType);
                        $('#' + this.fieldDatatype).data('kendoComboBox').enable(false);
                    } else {
                        if (selectedItem.storedItem.DataType != null && selectedItem.storedItem.DataType != "") {
                            $('#' + this.fieldDatatype).data('kendoComboBox').value(selectedItem.storedItem.DataType);
                        }
                    }
                } else {
                    if (selectedItem.storedItem.DataType != null && selectedItem.storedItem.DataType != "") {
                        $('#' + this.fieldDatatype).data('kendoComboBox').value(selectedItem.storedItem.DataType);
                        $('#' + this.fieldDatatype).data('kendoComboBox').enable(true);
                    }
                }

                this._handleDataTypeChange(e);
            },
            change: (e) => {
                this._handleDataTypeChange(e);
            }
        });

        $("#" + this.fieldNotNull).kendoSwitch({
            messages: {
                checked: this._getGeneralResource('SWITCH_ON'),
                unchecked: this._getGeneralResource('SWITCH_OFF')
            },
            checked: selectedItem.storedItem.NotNull
        });

        $('#' + this.fieldName).on('focusout', () => {
            $('#' + this.fieldLabel)[0].innerHTML = $('#' + this.fieldName).val();
            this._handleFieldName(node, $('#' + this.fieldName).val());
        });
    }

    _handleFieldName(node, fieldName) {
        let selectedItem = $('#' + this.fieldsTreeItem).data("kendoTreeView").dataItem(node);
        if (selectedItem.displayText != fieldName) {
            let currentNodes = $('#' + this.fieldsTreeItem).data("kendoTreeView").dataSource.data();
            let match = currentNodes.filter(currentNode => { return currentNode.displayText == fieldName });

            if (match.length > 0) {
                $('#FieldName-validation')[0].innerHTML = this._getEntityResource('FieldAlreadyExists');
            } else {
                let realMatch = this.realFields.filter(realField => { return realField.FieldName == fieldName });

                if (realMatch.length > 0) {
                    selectedItem.set('virtual', false);
                    selectedItem.storedItem.DbDataType = realMatch[0].DbDataType;
                    selectedItem.storedItem.DataType = $('#' + this.fieldDatatype).data('kendoComboBox').value();
                    $('#' + this.fieldDatatype).data('kendoComboBox').dataSource.read();
                } else {
                    selectedItem.set('virtual', true);
                    $('#' + this.fieldDatatype).data('kendoComboBox').dataSource.read();
                }

                $('#FieldName-validation')[0].innerHTML = '';
                selectedItem.set('displayText', fieldName);
                selectedItem.storedItem.FieldName = fieldName;
            }
        }
    }

    _handleDataTypeChange(item) {
        let dataType = item.sender.value();
        this.selectedField.storedItem.DataType = dataType;

        if (dataType != null && dataType != '') {
            $.ajax({
                url: rootURL + 'Entity/GetFieldDataSubType?dataType=' + dataType,
                type: 'GET',
                async: true,
                dataType: 'json',
                contentType: "application/json",
                success: (subTypeResult) => {
                    this.subTypeOptions = subTypeResult;
                    this._handleSubTypeOptions(dataType, this.selectedField.storedItem);
                }
            });
        } else {
            $('#' + this.specialFieldsItem)[0].innerHTML = '';
            this._validateField(this.selectedField.storedItem);
        }
    }

    _handleSubTypeOptions(dataType, item) {
        let subTypeOptions = [];

        this.subTypeOptions.forEach(subTypeOption => {
            subTypeOptions.push({
                id: subTypeOption.Id,
                name: subTypeOption.Name,
                type: 'subTypeOption'
            });
        });

        if (dataType == 'STRING') {
            $('#' + this.specialFieldsItem)[0].innerHTML = `<div class="form-row mb-4">
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this._getEntityResource('FieldLength') + `</label>
                                <input type="number" id="` + this.fieldLength + `" class="form-control" autocomplete="off"/>
                                <span id="Length-validation" class="field-error-message"></span>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this._getEntityResource('FieldDefValue') + `</label>
                                <a href="javascript:void(0);" class="btn btn-field-info btn-icon fs-xl width-1 mr-1 btn-light" data-toggle="popover" data-trigger="focus" data-placement="top" data-html="true"
                                    data-content="` + this._getEntityResource('FieldDefValue') + `" style="line-height: 1rem;">
                                    <i class="fal fa-question-circle color-fusion-300"></i>
                                </a>
                                <span class="k-widget k-combobox" style="width: 100%;">
                                    <span tabindex="-1" unselectable="on" class="k-dropdown-wrap k-state-default k-state-hover">
                                        <input id="` + this.fieldDefValue + `" class="k-input" type="text" readonly>
                                        <span class="k-select" role="button" tabindex="-1" id="` + this.fieldDefValueEdit + `">
                                            <span class="fal fa-function"></span>
                                        </span>
                                    </span>
                                </span>
                                <span id="DefValue-validation" class="field-error-message"></span>
                            </div>
                        </div>
                    </div>`;
        } else if (dataType == 'GEOMETRY') {
            $('#' + this.specialFieldsItem)[0].innerHTML = `<div class="form-row">
                            <div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getEntityResource('Srid') + `</label>
                                    <div id="` + this.fieldSrid + `" class="form-control"></div>
                                    <span id="Srid-validation" class="field-error-message"></span>
                                </div>
                            </div>
                            <div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getEntityResource('AccuracyFieldName') + `</label>
                                    <div class="input-group" style="flex-wrap: nowrap;">
                                        <input id="` + this.fieldAccuracy + `" type="text" class="form-control" style="display:none;">
                                        <div id="` + this.fieldAccuracy + `-combo" class="form-control"></div>
                                        <div class="input-group-append" style="display: grid;">
                                            <button class="btn btn-sm waves-effect waves-themed rounded-circle" type="button" id="button-` + this.fieldAccuracy + `" onclick="fieldsControl._switchColumnMode('` + this.fieldAccuracy + `');" style="aspect-ratio: 1/1; height: 2rem; padding: 0; border-radius: 5px !important; width: 2rem; margin-left: 0.5rem; justify-self: center; align-self: center;"><i class="fal fa-list-alt" style="font-size:1rem;"></i></button>
                                        </div>
                                    </div>
                                    <span id="AccuracyFieldName-validation" class="field-error-message"></span>
                                </div>
                            </div>
                            <div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getEntityResource('AltitudeFieldName') + `</label>
                                    <div class="input-group" style="flex-wrap: nowrap;">
                                        <input id="` + this.fieldAltitude + `" type="text" class="form-control" style="display:none;">
                                        <div id="` + this.fieldAltitude + `-combo" class="form-control"></div>
                                        <div class="input-group-append" style="display: grid;">
                                            <button class="btn btn-sm waves-effect waves-themed rounded-circle" type="button" id="button-` + this.fieldAltitude + `" onclick="fieldsControl._switchColumnMode('` + this.fieldAltitude + `');" style="aspect-ratio: 1/1; height: 2rem; padding: 0; border-radius: 5px !important; width: 2rem; margin-left: 0.5rem; justify-self: center; align-self: center;"><i class="fal fa-list-alt" style="font-size:1rem;"></i></button>
                                        </div>
                                    </div>
                                    <span id="AltitudeFieldName-validation" class="field-error-message"></span>
                                </div>
                            </div>
                        </div>`;
        } else if (dataType != 'BYTEA') {
            $('#' + this.specialFieldsItem)[0].innerHTML = `<div class="form-row">
                    <div class="col-sm-6 mb-3">
                        <div class="form-group">
                            <label class="form-label">` + this._getEntityResource('FieldDefValue') + `</label>
                            <a href="javascript:void(0);" class="btn btn-field-info btn-icon fs-xl width-1 mr-1 btn-light" data-toggle="popover" data-trigger="focus" data-placement="top" data-html="true"
                                data-content="` + this._getEntityResource('FieldDefValue') + `" style="line-height: 1rem;">
                                <i class="fal fa-question-circle color-fusion-300"></i>
                            </a>
                            <span class="k-widget k-combobox" style="width: 100%;">
                                <span tabindex="-1" unselectable="on" class="k-dropdown-wrap k-state-default k-state-hover">
                                    <input id="` + this.fieldDefValue + `" class="k-input" type="text" readonly>
                                    <span class="k-select" role="button" tabindex="-1" id="` + this.fieldDefValueEdit + `">
                                        <span class="fal fa-function"></span>
                                    </span>
                                </span>
                            </span>
                            <span id="DefValue-validation" class="field-error-message"></span>
                        </div>
                    </div>
                </div>`;
        }

        if (subTypeOptions.length > 0) {
            let subtypeItemsTemplate = this._getSubtypeItemsTemplate(subTypeOptions, dataType);

            $('#' + this.specialFieldsItem)[0].innerHTML += subtypeItemsTemplate;
            this._validateField(this.selectedField.storedItem);
        } else {
            let template = `<div id="field-special-field-wrapper" style="display: none;">`;
            template += `</div>`;

            $('#' + this.specialFieldsItem)[0].innerHTML += template;

            let specialTypeUrl = rootURL + 'Entity/GetFieldSpecialType?dataType=' + dataType;

            $.ajax({
                url: specialTypeUrl,
                type: 'GET',
                async: true,
                dataType: 'json',
                contentType: "application/json",
                success: (specialTypeResult) => {
                    this.specialOptions = specialTypeResult;
                    this._handleSpecialOptions(dataType);
                    this._validateField(this.selectedField.storedItem);
                }
            });
        }

        this._createSubtypeSwitches(subTypeOptions, dataType);
    }

    _switchColumnMode(selector) {
        if ($("#button-" + selector).hasClass("btn-primary")) {
            $("#" + selector).show();
            $("#" + selector + '-combo').data("kendoComboBox").wrapper.hide();

            $("#button-" + selector).removeClass("btn-primary");
        }
        else {
            $("#" + selector).hide();
            $("#" + selector + '-combo').data("kendoComboBox").wrapper.show();

            $("#button-" + selector).addClass("btn-primary");

            var source = $("#" + selector).val();
            $("#" + selector + '-combo').data("kendoComboBox").select(function (dataItem) {
                return dataItem.Name === source;
            });

            if ($("#" + selector + '-combo').data("kendoComboBox").value() == '') {
                $("#" + selector).val('');
            }
        }
    }

    _validateField(item) {
        if (item.InvalidProperties != null && item.InvalidProperties.length > 0) {
            item.InvalidProperties.forEach(property => {
                if ($('#' + property.PropertyName + '-validation').length > 0) {
                    $('#' + property.PropertyName + '-validation')[0].innerHTML = property.Message;
                }
            });
        }
    }

    _createSubtypeSwitches(subTypeOptions, dataType) {
        let subTypeSelected = false;

        subTypeOptions.forEach(option => {
            $('#subtype-option-choice-' + option.id).kendoSwitch({
                messages: {
                    checked: this._getGeneralResource('SWITCH_ON'),
                    unchecked: this._getGeneralResource('SWITCH_OFF')
                },
                checked: false,
                change: (e) => {
                    let id = e.sender.element.attr('id').replaceAll('subtype-option-choice-', '');
                    let subTypeId = null;
                    if (e.checked) {
                        subTypeOptions.forEach(option => {
                            if (option.id != id) {
                                $('#subtype-option-choice-' + option.id).data('kendoSwitch').check(false);
                            }
                        });

                        $('#field-foreign-key-wrapper').hide();
                        $('#field-file-wrapper').hide();

                        if (id == 'FOREIGN_KEY') {
                            $('#field-foreign-key-wrapper').show();
                        }

                        if (id == 'FILE') {
                            $('#field-file-wrapper').show();
                        }

                        subTypeId = id;
                    } else {
                        if (id == 'FOREIGN_KEY') {
                            $('#field-foreign-key-wrapper').hide();
                        }

                        if (id == 'FILE') {
                            $('#field-file-wrapper').hide();
                        }

                        subTypeId = null;
                    }

                    let specialTypeUrl = rootURL + 'Entity/GetFieldSpecialType?dataType=' + dataType;

                    if (subTypeId != null) {
                        specialTypeUrl += '&dataSubType=' + id;
                    }

                    $.ajax({
                        url: specialTypeUrl,
                        type: 'GET',
                        async: true,
                        dataType: 'json',
                        contentType: "application/json",
                        success: (specialTypeResult) => {
                            this.specialOptions = specialTypeResult;
                            this._handleSpecialOptions(dataType);
                        }
                    });
                }
            });

            if (!this.selectedFieldShown) {
                if (this.selectedField.storedItem.DataSubType == option.id) {
                    $('#subtype-option-choice-' + option.id).data('kendoSwitch').check(true);
                    if (option.id == 'FOREIGN_KEY') {
                        $('#field-foreign-key-wrapper').show();
                    }

                    if (option.id == 'FILE') {
                        $('#field-file-wrapper').show();
                    }

                    subTypeSelected = true;
                    let specialTypeUrl = rootURL + 'Entity/GetFieldSpecialType?dataType=' + dataType + '&dataSubType=' + option.id;

                    $.ajax({
                        url: specialTypeUrl,
                        type: 'GET',
                        async: true,
                        dataType: 'json',
                        contentType: "application/json",
                        success: (specialTypeResult) => {
                            this.specialOptions = specialTypeResult;
                            this._handleSpecialOptions(dataType);
                        }
                    });
                }
            }
        });

        if (!subTypeSelected) {
            let specialTypeUrl = rootURL + 'Entity/GetFieldSpecialType?dataType=' + dataType;

            $.ajax({
                url: specialTypeUrl,
                type: 'GET',
                async: true,
                dataType: 'json',
                contentType: "application/json",
                success: (specialTypeResult) => {
                    this.specialOptions = specialTypeResult;
                    this._handleSpecialOptions(dataType);
                }
            });
        }


        $('#' + this.fieldSrid).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Name',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: true,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'SystCoord/GetSystCoords?text=' + $('#' + this.fieldSrid).data('kendoComboBox').text();
                        }
                    }
                }
            }
        });

        $('#' + this.fieldForeignKey).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: true,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'Entity/GetEntity?currentEntity=' + this.entityId + '&filter=' + $('#' + this.fieldForeignKey).data('kendoComboBox').text();
                        }
                    }
                }
            },
            change: (e) => {
                if (e.sender.value() != null && e.sender.value()) {
                    $('#' + this.fieldForeignKey + '-navigator').show();
                } else {
                    $('#' + this.fieldForeignKey + '-navigator').hide();
                }
            }
        });

        $('#' + this.fieldMimeType + '-combo').kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Name',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: this._getDbFieldNames("STRING"),
            dataBound: (e) => {
                this._setupColumnNodedataBound(e.sender, this.fieldMimeType);
            },
            change: (e) => {
                this._setupColumnNodedataChange(this.fieldMimeType);
            }
        });

        $('#' + this.fieldFileName + '-combo').kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Name',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: this._getDbFieldNames("STRING"),
            dataBound: (e) => {
                this._setupColumnNodedataBound(e.sender, this.fieldFileName);
            },
            change: (e) => {
                this._setupColumnNodedataChange(this.fieldFileName);
            }
        });

        $('#' + this.fieldSrid).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Name',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: true,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'SystCoord/GetSystCoords?text=' + $('#' + this.fieldSrid).data('kendoComboBox').text();
                        }
                    }
                }
            }
        });

        $('#' + this.fieldGeolocated).kendoSwitch({
            messages: {
                checked: this._getGeneralResource('SWITCH_ON'),
                unchecked: this._getGeneralResource('SWITCH_OFF')
            },
            checked: false,
            change: (e) => {
                if (e.checked) {
                    $('#' + this.geolocatedFieldsItem).show();
                } else {
                    $('#' + this.geolocatedFieldsItem).hide();
                }
            }
        });

        $('#' + this.fieldCoord + '-combo').kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Name',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: this._getDbFieldNames('GEOMETRY'),
            dataBound: (e) => {
                this._setupColumnNodedataBound(e.sender, this.fieldCoord);
            },
            change: (e) => {
                this._setupColumnNodedataChange(this.fieldCoord);
            }
        });

        $('#' + this.fieldAltitude + '-combo').kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Name',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: this._getDbFieldNames("NUMERIC"),
            dataBound: (e) => {
                this._setupColumnNodedataBound(e.sender, this.fieldAltitude);
            },
            change: (e) => {
                this._setupColumnNodedataChange(this.fieldAltitude);
            }
        });

        $('#' + this.fieldAccuracy + '-combo').kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Name',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: this._getDbFieldNames("NUMERIC"),
            dataBound: (e) => {
                this._setupColumnNodedataBound(e.sender, this.fieldAccuracy);
            },
            change: (e) => {
                this._setupColumnNodedataChange(this.fieldAccuracy);
            }
        });

        if (!this.selectedFieldShown) {
            if ($('#' + this.fieldLength).length > 0 && this.selectedField.storedItem.Length != null && this.selectedField.storedItem.Length != '') {
                $('#' + this.fieldLength).val(this.selectedField.storedItem.Length);
            }

            if ($('#' + this.fieldForeignKey).data('kendoComboBox') != null && this.selectedField.storedItem.IdEntityFK != null && this.selectedField.storedItem.IdEntityFK > 0) {
                $('#' + this.fieldForeignKey + '-navigator').show();
                $('#' + this.fieldForeignKey).data('kendoComboBox').value(this.selectedField.storedItem.IdEntityFK);
            } else {
                $('#' + this.fieldForeignKey + '-navigator').hide();
            }

            if ($('#' + this.fieldSrid).data('kendoComboBox') != null && this.selectedField.storedItem.Srid != null && this.selectedField.storedItem.Srid != '') {
                $('#' + this.fieldSrid).data('kendoComboBox').value(this.selectedField.storedItem.Srid);
            }

            this._setupColumnNodeKeyup(this.fieldMimeType, 'MimeTypeFieldName');
            this._setupColumnNodeKeyup(this.fieldAltitude, 'AltitudeFieldName');
            this._setupColumnNodeKeyup(this.fieldAccuracy, 'AccuracyFieldName');
            this._setupColumnNodeKeyup(this.fieldFileName, 'FileNameFieldName');
            this._setupColumnNodeKeyup(this.fieldCoord, 'CoordFieldName');

            if ($('#' + this.fieldStoreFilePath).length > 0 && this.selectedField.storedItem.StoreFilePath != null && this.selectedField.storedItem.StoreFilePath != '') {
                $('#' + this.fieldStoreFilePath).val(this.selectedField.storedItem.StoreFilePath);
            }

            if ($('#' + this.fieldAcceptMimeType).length > 0 && this.selectedField.storedItem.AcceptMimeType != null && this.selectedField.storedItem.AcceptMimeType != '') {
                $('#' + this.fieldAcceptMimeType).val(this.selectedField.storedItem.AcceptMimeType);
            }

            if ($('#' + this.fieldMaxFileSize).length > 0 && this.selectedField.storedItem.MaxFileSize != null && this.selectedField.storedItem.MaxFileSize != '') {
                $('#' + this.fieldMaxFileSize).val(this.selectedField.storedItem.MaxFileSize);
            }
        }

        if (this.selectedField.storedItem.DefValue != null && this.selectedField.storedItem.DefValue.ValueType != null) {
            if (this.selectedField.storedItem.DefValue.ValueType == 'VALUE' && this.selectedField.storedItem.DefValue.Value != null) {
                $('#' + this.fieldDefValue).val(this.selectedField.storedItem.DefValue.Value);
            } else if (this.selectedField.storedItem.DefValue.ValueType == 'TOKEN' && this.selectedField.storedItem.DefValue.Token != null) {
                $('#' + this.fieldDefValue).val(this.selectedField.storedItem.DefValue.Token);
            } else if (this.selectedField.storedItem.DefValue.ValueType == 'SQL' && this.selectedField.storedItem.DefValue.Sql != null) {
                $('#' + this.fieldDefValue).val(this.selectedField.storedItem.DefValue.Sql);
            }
        }

        $('#' + this.fieldDefValueEdit).on('click', () => {
            this._handleDefValueEdit();
        });

        this.selectedFieldShown = true;
        this._validateField(this.selectedField.storedItem);
    }

    _getDbFieldNames(dataType) {
        let result = [];

        this.realFields.forEach(realField => {
            if (dataType == null) {
                result.push({ Name: realField.FieldName });
            }
            else if (Array.isArray(dataType)) {
                if (dataType.find((element) => element == realField.DataType) != null) {
                    result.push({ Name: realField.FieldName });
                }
            }
            else {
                if (realField.DataType == dataType) {
                    result.push({ Name: realField.FieldName });
                }
            }
        });

        return result;
    }

    _setupColumnNodedataChange(selector) {
        var cbSrc = $('#' + selector + '-combo').data("kendoComboBox");

        $('#' + selector).val(cbSrc.text());
    }

    _setupColumnNodedataBound(sender, selector) {
        if (sender.dataSource.total() == 0) {
            var cbSrc = $('#' + selector + '-combo').data("kendoComboBox");

            $('#' + selector).val(cbSrc.text());
        }

        setTimeout(() => {
            this._checkColumnMode(selector);
        }, 10);
    }

    _setupColumnNodeKeyup(selector, property) {
        if ($('#' + selector).length > 0) {
            $('#' + selector).val(this.selectedField.storedItem[property]);
            $('#' + selector).on('keyup', () => {
                this._checkColumnMode(selector);
            });
            $('#' + selector + '-combo').data('kendoComboBox').value(this.selectedField.storedItem[property]);
        }
    }

    _checkColumnMode(selector) {
        let sourceValue = $("#" + selector).val();
        let sourceControl = $("#" + selector + '-combo').data("kendoComboBox");
        var isManual = true;

        if (sourceValue == null || sourceValue.trim() == '') {
            isManual = false;
        } else if (sourceControl != null && sourceControl.dataSource != null && sourceControl.dataSource._data != null && sourceControl.dataSource._data.length > 0) {
            var potentialValues = $("#" + selector + '-combo').data("kendoComboBox").dataSource._data;
            for (var i = 0; i < potentialValues.length; i++) {
                if (($("#" + selector + '-combo').data("kendoComboBox").wrapper.css('display') != 'none' && $("#" + selector + '-combo').data("kendoComboBox").dataSource.total() != 0 && potentialValues[i].Name.toLowerCase().indexOf(sourceControl.text().toLowerCase()) >= 0)
                    || ($("#" + selector).css('display') != 'none' && potentialValues[i].Name == sourceValue)) {
                    isManual = false;
                    break;
                }
            }
        }

        if (isManual) {
            $("#" + selector).show();
            $("#" + selector + '-combo').data("kendoComboBox").wrapper.hide();
            $("#button-" + selector).removeClass("btn-primary");
        } else {
            $("#" + selector).hide();
            if ($("#" + selector + '-combo').data("kendoComboBox").wrapper.css('display') == 'none') {
                $("#" + selector + '-combo').data("kendoComboBox").value(sourceValue);
            }
            $("#" + selector + '-combo').data("kendoComboBox").wrapper.show();
            $("#button-" + selector).addClass("btn-primary");
        }
    }

    _handleSpecialOptions(dataType) {
        let specialOptions = [];

        this.specialOptions.forEach(specialOption => {
            let canBeAdded = true;

            $('#' + this.fieldsTreeItem).data('kendoTreeView').dataSource.data().forEach(node => {
                if (node.index != this.selectedField.index && node.storedItem.SpecialFieldType == specialOption.Id) {
                    canBeAdded = false;
                }
            });

            if (canBeAdded) {
                specialOptions.push({
                    id: specialOption.Id,
                    name: specialOption.Name,
                    type: 'specialOption'
                });
            }
        });

        if (specialOptions.length > 0) {
            let specialItemsTemplate = this._getSpecialItemsTemplate(specialOptions, dataType);
            $('#field-special-field-wrapper')[0].innerHTML = specialItemsTemplate;
            $('#field-special-field-wrapper').show();

            if (dataType == 'BYTEA') {
                $('#field-bytea-wrapper').show();

                $('#' + this.fieldGeolocated).kendoSwitch({
                    messages: {
                        checked: this._getGeneralResource('SWITCH_ON'),
                        unchecked: this._getGeneralResource('SWITCH_OFF')
                    },
                    checked: false,
                    change: (e) => {
                        if (e.checked) {
                            $('#' + this.geolocatedFieldsItem).show();
                        } else {
                            $('#' + this.geolocatedFieldsItem).hide();
                        }
                    }
                });

                $('#' + this.fieldMimeType + '-combo').kendoComboBox({
                    dataTextField: 'Name',
                    dataValueField: 'Name',
                    filter: 'contains',
                    suggest: true,
                    ignoreCase: true,
                    dataSource: this._getDbFieldNames("STRING"),
                    dataBound: (e) => {
                        this._setupColumnNodedataBound(e.sender, this.fieldMimeType);
                    },
                    change: (e) => {
                        this._setupColumnNodedataChange(this.fieldMimeType);
                    }
                });

                $('#' + this.fieldFileName + '-combo').kendoComboBox({
                    dataTextField: 'Name',
                    dataValueField: 'Name',
                    filter: 'contains',
                    suggest: true,
                    ignoreCase: true,
                    dataSource: this._getDbFieldNames("STRING"),
                    dataBound: (e) => {
                        this._setupColumnNodedataBound(e.sender, this.fieldFileName);
                    },
                    change: (e) => {
                        this._setupColumnNodedataChange(this.fieldFileName);
                    }
                });

                $('#' + this.fieldSrid).kendoComboBox({
                    dataTextField: 'Name',
                    dataValueField: 'Name',
                    filter: 'contains',
                    suggest: true,
                    ignoreCase: true,
                    dataSource: {
                        serverFiltering: true,
                        transport: {
                            read: {
                                dataType: 'json',
                                url: () => {
                                    return rootURL + 'SystCoord/GetSystCoords?text=' + $('#' + this.fieldSrid).data('kendoComboBox').text();
                                }
                            }
                        }
                    }
                });

                $('#' + this.fieldCoord + '-combo').kendoComboBox({
                    dataTextField: 'Name',
                    dataValueField: 'Name',
                    filter: 'contains',
                    suggest: true,
                    ignoreCase: true,
                    dataSource: this._getDbFieldNames("GEOMETRY"),
                    dataBound: (e) => {
                        this._setupColumnNodedataBound(e.sender, this.fieldCoord);
                    },
                    change: (e) => {
                        this._setupColumnNodedataChange(this.fieldCoord);
                    }
                });

                $('#' + this.fieldAltitude + '-combo').kendoComboBox({
                    dataTextField: 'Name',
                    dataValueField: 'Name',
                    filter: 'contains',
                    suggest: true,
                    ignoreCase: true,
                    dataSource: this._getDbFieldNames("NUMERIC"),
                    dataBound: (e) => {
                        this._setupColumnNodedataBound(e.sender, this.fieldAltitude);
                    },
                    change: (e) => {
                        this._setupColumnNodedataChange(this.fieldAltitude);
                    }
                });

                $('#' + this.fieldAccuracy + '-combo').kendoComboBox({
                    dataTextField: 'Name',
                    dataValueField: 'Name',
                    filter: 'contains',
                    suggest: true,
                    ignoreCase: true,
                    dataSource: this._getDbFieldNames("NUMERIC"),
                    dataBound: (e) => {
                        this._setupColumnNodedataBound(e.sender, this.fieldAccuracy);
                    },
                    change: (e) => {
                        this._setupColumnNodedataChange(this.fieldAccuracy);
                    }
                });
            }

            this._setupColumnNodeKeyup(this.fieldMimeType, 'MimeTypeFieldName');
            this._setupColumnNodeKeyup(this.fieldFileName, 'FileNameFieldName');
            this._setupColumnNodeKeyup(this.fieldCoord, 'CoordFieldName');
            this._setupColumnNodeKeyup(this.fieldAltitude, 'AltitudeFieldName');
            this._setupColumnNodeKeyup(this.fieldAccuracy, 'AccuracyFieldName');

            if ($('#' + this.fieldAcceptMimeType).length > 0 && this.selectedField.storedItem.AcceptMimeType != null && this.selectedField.storedItem.AcceptMimeType != '') {
                $('#' + this.fieldAcceptMimeType).val(this.selectedField.storedItem.AcceptMimeType);
            }

            if ($('#' + this.fieldMaxFileSize).length > 0 && this.selectedField.storedItem.MaxFileSize != null && this.selectedField.storedItem.MaxFileSize != '') {
                $('#' + this.fieldMaxFileSize).val(this.selectedField.storedItem.MaxFileSize);
            }

            if ($('#' + this.fieldSrid).data('kendoComboBox') != null && this.selectedField.storedItem.Srid != null && this.selectedField.storedItem.Srid != '') {
                $('#' + this.fieldSrid).data('kendoComboBox').value(this.selectedField.storedItem.Srid);
            }

            if ($('#' + this.fieldGeolocated).data('kendoSwitch') != null) {
                if (this.selectedField.storedItem.Geolocated) {
                    $('#' + this.fieldGeolocated).data('kendoSwitch').check(true);
                    $('#' + this.geolocatedFieldsItem).show();
                } else {
                    $('#' + this.fieldGeolocated).data('kendoSwitch').check(false);
                    $('#' + this.geolocatedFieldsItem).hide();
                }
            }
        } else {
            $('#field-special-field-wrapper').hide();
        }

        specialOptions.forEach(option => {
            $('#special-option-choice-' + option.id).kendoSwitch({
                messages: {
                    checked: this._getGeneralResource('SWITCH_ON'),
                    unchecked: this._getGeneralResource('SWITCH_OFF')
                },
                checked: false,
                change: (e) => {
                    let id = e.sender.element.attr('id').replaceAll('special-option-choice-', '');
                    if (e.checked) {
                        specialOptions.forEach(option => {
                            if (option.id != id) {
                                $('#special-option-choice-' + option.id).data('kendoSwitch').check(false);
                            }
                        });
                    }
                }
            });

            if (this.selectedField.storedItem.SpecialFieldType == option.id) {
                $('#special-option-choice-' + option.id).data('kendoSwitch').check(true);
            }
        });
        this._validateField(this.selectedField.storedItem);
    }

    _initEvents() {
        $('#' + this.fieldsFilterItem).on('input', (evt) => {
            this._filterTree();
        });

        $('#' + this.addVirtualFieldButtonItem).on('click', () => {
            this._addVirtualField();
        });

        $('#' + this.addFieldButtonItem).on('click', () => {
            this._addField();
        });
    }

    _addVirtualField() {
        let currentNodes = $('#' + this.fieldsTreeItem).data("kendoTreeView").dataSource.data();

        let index = 0;

        let newNodes = [];

        this._storeExistingTreeFields(newNodes, currentNodes, index);

        newNodes.push({
            storedItem: {
                Id: 0,
                Virtual: true,
                FieldName: this._getEntityResource("Nedefinit"),
                DataType: "",
                NotNull: false,
                Description: "",
                DataSubType: "",
                SpecialFieldType: ""
            },
            index: ++index,
            displayText: this._getEntityResource("Nedefinit"),
            virtual: true,
            items: []
        });

        let dataSource = new kendo.data.HierarchicalDataSource({
            data: newNodes, schema: {
                model: {
                    id: "index",
                    children: "items"
                }
            }
        });

        $('#' + this.fieldsTreeItem).data("kendoTreeView").setDataSource(dataSource);

        $('#' + this.fieldsTreeItem).data("kendoTreeView").select('.k-last');
        this._selectNode('.k-item.k-last');
    }

    _storeExistingTreeFields(storage, fields, index) {
        fields.forEach(field => {
            storage.push({
                storedItem: field.storedItem,
                index: ++index,
                displayText: field.displayText,
                virtual: field.virtual,
                items: []
            });
        });

        return index;
    }

    _addField() {
        $('#' + this.fieldsDatabaseWrapper)[0].innerHTML = `<div class="pr-0" id="` + this.fieldsDatabaseItem + `"></div>`;

        let windowOptions = {
            draggable: false,
            resizable: true,
            width: "25rem",
            height: "30rem",
            title: this._getEntityResource('DatabaseFieldsTitle'),
            modal: true,
            close: () => { this._closeWindow(); }
        };

        $('#' + this.fieldsDatabaseItem).kendoWindow(windowOptions);
        $('#' + this.fieldsDatabaseItem).data("kendoWindow").center();
        this._clearFilter();
        this._initDatabaseFieldsWindow();
    }

    _closeWindow() {
        $('#' + this.fieldsDatabaseItem).data("kendoWindow").destroy();
    }

    _clearFilter() {
        $('#' + this.fieldsFilterItem).val('');
        this._filterTree();
    }

    _initDatabaseFieldsWindow() {
        let template = `<div style="height: calc(100% - 4.5rem); overflow-x: hidden; overflow-y: auto; margin-bottom: 1rem; margin-right: 0.8rem;" id="database-field-content-wrapper">` +
                            this._getAvailableDatabaseFields()
                        + `</div>
                        <div class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right pr-0 pb-0 mr-3">
                            <button class="btn btn-secondary ml-auto mt-3" onclick="fieldsControl._closeWindow()" title="` + this._getGeneralResource('CancelChanges') + `" type="button">` + this._getGeneralResource('Cancel') + `</button>
                            <button class="btn btn-primary ml-2 mt-3" onclick="fieldsControl._selectDatabaseFields()" title="` + this._getGeneralResource('SaveChanged') + `" type="button">` + this._getGeneralResource('Save') + `</button>
                        </div>`;

        $('#' + this.fieldsDatabaseItem)[0].innerHTML = template;

        $('#check-all').on('change', () => {
            if ($('#check-all')[0].checked) {
                $('.database-field-item').attr('checked', true);
            } else {
                $('.database-field-item').attr('checked', false);
            }
        });
    }

    _selectDatabaseFields() {
        let fields = $('.database-field-item');
        let checkedFields = this._domToFields(fields.filter(field => { return fields[field].checked }));

        let existingNodes = $('#' + this.fieldsTreeItem).data('kendoTreeView').dataSource.data();
        let newNodes = [];
        let index = 0;

        existingNodes.forEach(existingNode => {
            let checked = checkedFields.filter(checkedField => { return checkedField.FieldName == existingNode.displayText });

            if (existingNode.virtual == true) {
                if (checked.length > 0) {
                    index = this._storeExistingTreeField(newNodes, existingNode, index, false);
                }
                else {
                    index = this._storeExistingTreeField(newNodes, existingNode, index, true);
                }
            } else {
                if (checked.length > 0) {
                    index = this._storeExistingTreeField(newNodes, existingNode, index, false);
                }
            }
        });

        checkedFields.forEach(checkedField => {
            var existingFields = newNodes.filter(node => { return node.displayText == checkedField.FieldName });

            if (existingFields.length == 0) {
                newNodes.push({
                    storedItem: checkedField,
                    index: ++index,
                    displayText: checkedField.FieldName,
                    virtual: false,
                    items: []
                });
            }
        });

        let dataSource = new kendo.data.HierarchicalDataSource({
            data: newNodes, schema: {
                model: {
                    id: "index",
                    children: "items"
                }
            }
        });

        $('#' + this.fieldsTreeItem).data("kendoTreeView").setDataSource(dataSource);
        this._destroyFieldDetails();
        this._closeWindow();
    }

    _domToFields(domItems) {
        let result = [];

        for (var i = 0; i < domItems.length; i++) {
            let domItem = domItems[i];
            let id = domItem.id;
            let realItems = this.realFields.filter(realField => { return realField.FieldName == id });

            if (realItems.length > 0) {
                result.push(realItems[0]);
            }
        }

        return result;
    }

    _storeExistingTreeField(storage, field, index, virtual) {
        storage.push({
            storedItem: field.storedItem,
            index: ++index,
            displayText: field.displayText,
            virtual: virtual,
            items: []
        });

        return index;
    }

    _handleDefValueEdit() {
        if (this.selectedField.storedItem.DefValue == null) {
            this.selectedField.storedItem.DefValue = {
                Value: null,
                ValueType: (this.selectedField.storedItem.DataType != 'GEOMETRY' && this.selectedField.storedItem.DataType != 'BYTEA' ? 'VALUE' : 'SQL'),
                ApplyTo: 'NEW'
            };
        }

        $('#' + this.fieldsDatabaseWrapper)[0].innerHTML = `<div class="pr-0" id="` + this.fieldsDatabaseItem + `"></div>`;

        let windowOptions = {
            draggable: false,
            resizable: true,
            width: "40rem",
            height: "auto",
            title: this._getEntityResource('EditValue'),
            modal: true,
            close: () => { this._closeWindow(); }
        };

        $('#' + this.fieldsDatabaseItem).kendoWindow(windowOptions);
        this._initDefValueWindow();
        $('#' + this.fieldsDatabaseItem).data("kendoWindow").center();
    }

    _initDefValueWindow() {
        let template = `<div style="height: calc(100% - 4.5rem); overflow-x: hidden; overflow-y: auto; margin-bottom: 1rem; margin-right: 0.8rem;">
                            <div class="form-row">
                                <div class="col-xl-12 mb-3">
                                    <div class="frame-wrap mb-0">
                                        <div id="` + this.fieldDefValueType + `" class="btn-group btn-group-toggle btn-group-sm" data-toggle="buttons">`
                                            + (this.selectedField.storedItem.DataType != 'BYTEA' && this.selectedField.storedItem.DataType != 'GEOMETRY' ? `
                                            <label class="btn btn-secondary" style="width: 4.5rem;">
                                                <input type="radio" name="options" data-option="VALUE">` + this._getEntityResource('ValueType_Value') + `
                                            </label>
                                            <label class="btn btn-secondary" style="width: 4.5rem;">
                                                <input type="radio" name="options" data-option="TOKEN">` + this._getEntityResource('ValueType_Token') + `
                                            </label>
                                            `: ``) +
                                            `<label class="btn btn-secondary" style="width: 4.5rem;">
                                                <input type="radio" name="options" data-option="SQL">` + this._getEntityResource('ValueType_Sql') + `
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-row" id="` + this.fieldDefValueValue + `-wrapper" style="display: none;">
                                 <div class="col-sm-12 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">` + this._getEntityResource('ValueType_Value') + `</label>`
                                        + this._getDefValueValueTemplate() +
                                        `<span id="` + this.fieldDefValueValue + `-validation" class="invalid-feedback"></span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-row" id="` + this.fieldDefValueToken + `-wrapper" style="display: none;">
                                 <div class="col-sm-12 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">` + this._getEntityResource('ValueType_Token') + `</label>
                                        <div id="` + this.fieldDefValueToken + `" class="form-control"></div>
                                        <span id="` + this.fieldDefValueToken + `-validation" class="invalid-feedback"></span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-row" id="` + this.fieldDefValueSql + `-wrapper" style="display: none;">
                                 <div class="col-sm-12 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">` + this._getEntityResource('ValueType_Sql') + `</label>
                                        <textarea id="` + this.fieldDefValueSql + `" class="form-control"></textarea>
                                        <span id="` + this.fieldDefValueSql + `-validation" class="invalid-feedback"></span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-row">
                                 <div class="col-sm-12">
                                    <div class="form-group">
                                        <label class="form-label">` + this._getEntityResource('ApplyToFieldName') + `</label>
                                        <div id="` + this.fieldApplyTo + `" class="form-control"></div>
                                        <span id="` + this.fieldApplyTo + `-validation" class="invalid-feedback"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right pr-0 pb-0 mr-3">
                            <button class="btn btn-secondary ml-auto mt-3" onclick="fieldsControl._closeWindow()" title="` + this._getGeneralResource('CancelChanges') + `" type="button">` + this._getGeneralResource('Cancel') + `</button>
                            <button class="btn btn-primary ml-2 mt-3" onclick="fieldsControl._saveDefValue()" title="` + this._getGeneralResource('SaveChanged') + `" type="button">` + this._getGeneralResource('Save') + `</button>
                        </div>`;

        $('#' + this.fieldsDatabaseItem)[0].innerHTML = template;

        $('#' + this.fieldApplyTo).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: [{ Id: 'NEW', Name: this._getEntityResource('ApplyTo_NEW') }, { Id: 'EDIT', Name: this._getEntityResource('ApplyTo_EDIT') }, { Id: 'WHEN_NULL', Name: this._getEntityResource('ApplyTo_WHEN_NULL') }]
        });

        $('#' + this.fieldDefValueToken).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: true,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'Entity/GetTokenType?dataType=' + this.selectedField.storedItem.DataType;
                        }
                    }
                }
            }
        });

        if (this.selectedField.storedItem.DefValue.Token != null) {
            $('#' + this.fieldDefValueToken).data('kendoComboBox').value(this.selectedField.storedItem.DefValue.Token);
        }

        if (this.selectedField.storedItem.DefValue.Sql != null) {
            $('#' + this.fieldDefValueSql).val(this.selectedField.storedItem.DefValue.Sql);
        }

        if (this.selectedField.storedItem.DefValue.ApplyTo != null) {
            $('#' + this.fieldApplyTo).data('kendoComboBox').value(this.selectedField.storedItem.DefValue.ApplyTo);
        }

        $('#' + this.fieldDefValueType + ' input').on('change', (evt) => {
            $('#' + this.fieldDefValueType + ' label').removeClass("btn-primary").addClass("btn-secondary");
            $(evt.currentTarget).closest("label").removeClass("btn-secondary").addClass("btn-primary");

            let currentValueType = $(evt.currentTarget).attr('data-option');
                
            if (currentValueType == 'VALUE') {
                $('#' + this.fieldDefValueValue + '-wrapper').show();
                $('#' + this.fieldDefValueToken + '-wrapper').hide();
                $('#' + this.fieldDefValueSql + '-wrapper').hide();
            } else if (currentValueType == 'TOKEN') {
                $('#' + this.fieldDefValueValue + '-wrapper').hide();
                $('#' + this.fieldDefValueToken + '-wrapper').show();
                $('#' + this.fieldDefValueSql + '-wrapper').hide();
            } else {
                $('#' + this.fieldDefValueValue + '-wrapper').hide();
                $('#' + this.fieldDefValueToken + '-wrapper').hide();
                $('#' + this.fieldDefValueSql + '-wrapper').show();
            }
        });

        $('#' + this.fieldDefValueType + ' input[data-option="' + this.selectedField.storedItem.DefValue.ValueType + '"]').prop('checked', true);
        $('#' + this.fieldDefValueType + ' input[data-option="' + this.selectedField.storedItem.DefValue.ValueType + '"]').click();

        this._initDefValueValue();
    }

    _initDefValueValue() {
        switch (this.selectedField.storedItem.DataType) {
            case 'DATE': {
                    $("#" + this.fieldDefValueValue).kendoDatePicker();
                    if(this.selectedField.storedItem.DefValue.Value != null){
                        $("#" + this.fieldDefValueValue).data("kendoDatePicker").value(stringToDate1(this.selectedField.storedItem.DefValue.Value));
                    }
                }
                break;
            case 'TIMESTAMP': {
                    $("#" + this.fieldDefValueValue).kendoDateTimePicker();
                    $("#" + this.fieldDefValueValue).data("kendoDateTimePicker").value(stringToDate1(this.selectedField.storedItem.DefValue.Value));
                }
                break;
            case 'BOOLEAN': {
                    $("#" + this.fieldDefValueValue).kendoSwitch({
                        messages: {
                            checked: this._getGeneralResource('SWITCH_ON'),
                            unchecked: this._getGeneralResource('SWITCH_OFF')
                        },
                        checked: this.selectedField.storedItem.DefValue.Value != null && this.selectedField.storedItem.DefValue.Value == 'true'
                    });
                }
                break;
            case 'BOOLINT': {
                    $("#" + this.fieldDefValueValue).kendoSwitch({
                        messages: {
                            checked: this._getGeneralResource('SWITCH_ON'),
                            unchecked: this._getGeneralResource('SWITCH_OFF')
                        },
                        checked: this.selectedField.storedItem.DefValue.Value != null && this.selectedField.storedItem.DefValue.Value == '1'
                    });
                }
                break;
            default: {
                    if (this.selectedField.storedItem.DefValue.Value != null) {
                        $("#" + this.fieldDefValueValue).val(this.selectedField.storedItem.DefValue.Value);
                    }
                }
                break;
        }
    }

    _getDefValueValueTemplate() {
        let template = ``

        switch (this.selectedField.storedItem.DataType) {
            case 'STRING': template = `<input type="text" id="` + this.fieldDefValueValue + `" class="form-control" autocomplete="off"/>`;
                break;
            case 'NUMERIC': template = `<input type="number" id="` + this.fieldDefValueValue + `" class="form-control" autocomplete="off"/>`;
                break;
            case 'INTEGER': template = `<input type="number" id="` + this.fieldDefValueValue + `" class="form-control" autocomplete="off"/>`;
                break;
            case 'DATE': template = `<input id="` + this.fieldDefValueValue + `" class="form-control" autocomplete="off"/>`;
                break;
            case 'TIMESTAMP': template = `<input id="` + this.fieldDefValueValue + `" class="form-control" autocomplete="off"/>`;
                break;
            case 'GEOMETRY': template = ``;
                break;
            case 'BYTEA': template = ``;
                break;
            case 'BOOLEAN': template = `<div id="` + this.fieldDefValueValue + `" style="margin-left: 0.5rem;"></div>`;
                break;
            case 'BOOLINT': template = `<div id="` + this.fieldDefValueValue + `" style="margin-left: 0.5rem;"></div>`;
                break;
            default:
                break;
        }

        return template;
    }

    _saveDefValue() {
        this.selectedField.storedItem.DefValue.ApplyTo = $('#' + this.fieldApplyTo).data('kendoComboBox').value();

        let defValueType = 'VALUE';

        let valueTypeInputs = $('#' + this.fieldDefValueType + ' input');

        for (var i = 0; i < valueTypeInputs.length; i++) {
            if (valueTypeInputs[i].checked) {
                defValueType = $(valueTypeInputs[i]).attr('data-option');
            }
        }

        this.selectedField.storedItem.DefValue.ValueType = defValueType;

        if (defValueType == 'SQL') {
            this.selectedField.storedItem.DefValue.Sql = $('#' + this.fieldDefValueSql).val();
        } else if (defValueType == 'TOKEN') {
            this.selectedField.storedItem.DefValue.Token = $('#' + this.fieldDefValueToken).data('kendoComboBox').value();
        } else {
            switch (this.selectedField.storedItem.DataType) {
                case 'STRING': this.selectedField.storedItem.DefValue.Value = $('#' + this.fieldDefValueValue).val();
                    break;
                case 'NUMERIC': this.selectedField.storedItem.DefValue.Value = $('#' + this.fieldDefValueValue).val();
                    break;
                case 'INTEGER': this.selectedField.storedItem.DefValue.Value = $('#' + this.fieldDefValueValue).val();
                    break;
                case 'DATE': this.selectedField.storedItem.DefValue.Value = dateToString1($('#' + this.fieldDefValueValue).data("kendoDatePicker").value());
                    break;
                case 'TIMESTAMP': this.selectedField.storedItem.DefValue.Value = dateToString1($('#' + this.fieldDefValueValue).data("kendoDateTimePicker").value());
                    break;
                case 'BOOLEAN': this.selectedField.storedItem.DefValue.Value = $('#' + this.fieldDefValueValue).data('kendoSwitch').check() ? 'true' : 'false';
                    break;
                case 'BOOLINT': this.selectedField.storedItem.DefValue.Value = $('#' + this.fieldDefValueValue).data('kendoSwitch').check() ? '1' : '0';
                    break;
                default:
                    break;
            }
        }

        if (this.selectedField.storedItem.DefValue != null && this.selectedField.storedItem.DefValue.ValueType != null) {
            if (this.selectedField.storedItem.DefValue.ValueType == 'VALUE' && this.selectedField.storedItem.DefValue.Value != null) {
                $('#' + this.fieldDefValue).val(this.selectedField.storedItem.DefValue.Value);
            } else if (this.selectedField.storedItem.DefValue.ValueType == 'TOKEN' && this.selectedField.storedItem.DefValue.Token != null) {
                $('#' + this.fieldDefValue).val(this.selectedField.storedItem.DefValue.Token);
            } else if (this.selectedField.storedItem.DefValue.ValueType == 'SQL' && this.selectedField.storedItem.DefValue.Sql != null) {
                $('#' + this.fieldDefValue).val(this.selectedField.storedItem.DefValue.Sql);
            }
        }

        if (this.selectedField.storedItem.DefValue != null && (this.selectedField.storedItem.DefValue.Value == null || this.selectedField.storedItem.DefValue.Value == '') && this.selectedField.storedItem.DefValue.Token == null && this.selectedField.storedItem.DefValue.Sql == null) {
            this.selectedField.storedItem.DefValue = null;
        }

        this._closeWindow();
    }

    _openRefEntity(selector) {
        let value = $('#' + selector).data('kendoComboBox').value();

        if (value != null) {
            window.open(rootUrl + 'Entity/EntityForm?id=' + value, "_blank");
        }
    }

    /* TEMPLATES */

    _getFieldDefinitionTemplate() {
        let template = `<div class="form-row">
                            <div class="col-sm-12 d-flex align-items-center pb-2 border-bottom mb-3 ">
                                <h1 class="subheader-title ml-1 ml-lg-0 mt-2" id="` + this.fieldLabel + `" style="font-size: 1.3rem;"></h1>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getEntityResource('DenumireCamp') + `</label>
                                    <input type="text" id="` + this.fieldName + `" class="form-control" autocomplete="off"/>
                                    <span id="FieldName-validation" class="field-error-message"></span>
                                </div>
                            </div>
                            <div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getEntityResource('TipData') + `</label>
                                    <div id="` + this.fieldDatatype + `" class="form-control"></div>
                                    <span id="DataType-validation" class="field-error-message"></span>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this._getEntityResource('Descriere') + `</label>
                                    <textarea id="` + this.fieldDescription + `" class="form-control"></textarea>
                                    <span id="Description-validation" class="field-error-message"></span>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-sm-6 mb-3" style="align-content: center; display: flex; flex-wrap: wrap;">
                                <div class="form-group">
                                    <div id="` + this.fieldNotNull + `"></div>
                                    <label class="form-label ml-2">` + this._getEntityResource('NotNull') + `</label>
                                    <span id="NotNull-validation" class="field-error-message"></span>
                                </div>
                            </div>
                        </div>
                        <div id="` + this.specialFieldsItem + `">
                        </div>`;

        return template;
    }

    _getAvailableDatabaseFields() {
        let fieldsTemplate = '';

        fieldsTemplate += `<div class="form-row mb-3">
                                <div class="form-group mb-2 col-12">
                                    <input class="k-checkbox k-valid" id="check-all" name="` + this._getGeneralResource('SelectAll') + `" style="width:100%;" type="checkbox">
                                    <label class="k-checkbox-label form-label" for="check-all">` + this._getGeneralResource('SelectAll') + `</label>
                                </div> 
                               </div>`;

        this.realFields.forEach(realField => {
            let isChecked = false;

            let existingField = $('#' + this.fieldsTreeItem).data('kendoTreeView').dataSource.data().filter(existingField => { return existingField.displayText == realField.FieldName });

            if (existingField.length > 0) {
                isChecked = true;
            }

            fieldsTemplate += `<div class="form-row">
                                <div class="form-group mb-2 col-12">
                                    <input class="k-checkbox k-valid database-field-item" id="` + realField.FieldName + `" name="` + realField.FieldName + `" style="width:100%;" type="checkbox"` + (isChecked ? ' checked' : '') + `>
                                    <label class="k-checkbox-label form-label" for="` + realField.FieldName + `">` + realField.FieldName + '<span style="color:#4679cc; padding-left: 0.5rem;">(' + realField.DataType + ')</span>' + `</label>
                                </div> 
                               </div>`;
        });

        return fieldsTemplate;
    }

    _getSpecialItemsTemplate(options, dataType) {
        let template = `<div class="form-row mb-4">`;
        template += `<label class="form-label col-sm-2 mb-3">` + this._getEntityResource('SpecialItems') + `</label>`;
        options.forEach(option => {
            template += `<div class="col-sm-3 mb-3">
                            <div class="form-group">
                                <div option-type="` + option.type + `" class="special-option-choice" id="special-option-choice-` + option.id + `"></div>
                                <label class="form-label ml-2">` + option.name + `</label>
                            </div>
                        </div>`;
        });

        template += `</div>`;

        if (dataType == 'BYTEA') {
            template += `<div id="field-bytea-wrapper" style="display: none;">
                            <div class="form-row">
                                <div class="col-sm-12 d-flex align-items-center pb-2 border-bottom mb-3 ">
                                    <h3 class="subheader-title ml-1 ml-lg-0 mt-2" style="font-size: 1.1rem;">` + this._getEntityResource('AdvancedSettings') + `</h3>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-sm-6 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">` + this._getEntityResource('AcceptMimeType') + `</label>
                                        <input type="text" id="` + this.fieldAcceptMimeType + `" class="form-control" autocomplete="off"/>
                                        <span id="AcceptMimeType-validation" class="field-error-message"></span>
                                    </div>
                                </div>
                                <div class="col-sm-6 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">` + this._getEntityResource('MaxFileSize') + `</label>
                                        <input type="number" id="` + this.fieldMaxFileSize + `" class="form-control" autocomplete="off"/>
                                        <span id="MaxFileSize-validation" class="field-error-message"></span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-row mb-3">
                                <div class="col-sm-6 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">` + this._getEntityResource('FileNameField') + `</label>
                                        <div class="input-group" style="flex-wrap: nowrap;">
                                            <input id="` + this.fieldFileName + `" type="text" class="form-control" style="display:none;">
                                            <div id="` + this.fieldFileName + `-combo" class="form-control"></div>
                                            <div class="input-group-append" style="display: grid;">
                                                <button class="btn btn-sm waves-effect waves-themed rounded-circle" type="button" id="button-` + this.fieldFileName + `" onclick="fieldsControl._switchColumnMode('` + this.fieldFileName + `');" style="aspect-ratio: 1/1; height: 2rem; padding: 0; border-radius: 5px !important; width: 2rem; margin-left: 0.5rem; justify-self: center; align-self: center;"><i class="fal fa-list-alt" style="font-size:1rem;"></i></button>
                                            </div>
                                        </div>
                                        <span id="FileNameFieldName-validation" class="field-error-message"></span>
                                    </div>
                                </div>
                                <div class="col-sm-6 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">` + this._getEntityResource('MimeTypeField') + `</label>
                                        <div class="input-group" style="flex-wrap: nowrap;">
                                            <input id="` + this.fieldMimeType + `" type="text" class="form-control" style="display:none;">
                                            <div id="` + this.fieldMimeType + `-combo" class="form-control"></div>
                                            <div class="input-group-append" style="display: grid;">
                                                <button class="btn btn-sm waves-effect waves-themed rounded-circle" type="button" id="button-` + this.fieldMimeType + `" onclick="fieldsControl._switchColumnMode('` + this.fieldMimeType + `');" style="aspect-ratio: 1/1; height: 2rem; padding: 0; border-radius: 5px !important; width: 2rem; margin-left: 0.5rem; justify-self: center; align-self: center;"><i class="fal fa-list-alt" style="font-size:1rem;"></i></button>
                                            </div>
                                        </div>
                                        <span id="MimeTypeFieldName-validation" class="field-error-message"></span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-row mb-3">
                                <div class="col-sm-6 mb-3">
                                    <div class="form-group">
                                        <div id="` + this.fieldGeolocated + `"></div>
                                        <label class="form-label ml-2">` + this._getEntityResource('Geolocated') + `</label>
                                        <span id="Geolocated-validation" class="field-error-message"></span>
                                    </div>
                                </div>
                            </div>
                            <div id="` + this.geolocatedFieldsItem + `">
                                <div class="form-row">
                                    <div class="col-sm-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">` + this._getEntityResource('CoordFieldName') + `</label>
                                            <div class="input-group" style="flex-wrap: nowrap;">
                                                <input id="` + this.fieldCoord + `" type="text" class="form-control" style="display:none;">
                                                <div id="` + this.fieldCoord + `-combo" class="form-control"></div>
                                                <div class="input-group-append" style="display: grid;">
                                                    <button class="btn btn-sm waves-effect waves-themed rounded-circle" type="button" id="button-` + this.fieldCoord + `" onclick="fieldsControl._switchColumnMode('` + this.fieldCoord + `');" style="aspect-ratio: 1/1; height: 2rem; padding: 0; border-radius: 5px !important; width: 2rem; margin-left: 0.5rem; justify-self: center; align-self: center;"><i class="fal fa-list-alt" style="font-size:1rem;"></i></button>
                                                </div>
                                            </div>
                                            <span id="CoordFieldName-validation" class="field-error-message"></span>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">` + this._getEntityResource('Srid') + `</label>
                                            <div id="` + this.fieldSrid + `" class="form-control"></div>
                                            <span id="Srid-validation" class="field-error-message"></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row mb-4">
                                    <div class="col-sm-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">` + this._getEntityResource('AccuracyFieldName') + `</label>
                                            <div class="input-group" style="flex-wrap: nowrap;">
                                                <input id="` + this.fieldAccuracy + `" type="text" class="form-control" style="display:none;">
                                                <div id="` + this.fieldAccuracy + `-combo" class="form-control"></div>
                                                <div class="input-group-append" style="display: grid;">
                                                    <button class="btn btn-sm waves-effect waves-themed rounded-circle" type="button" id="button-` + this.fieldAccuracy + `" onclick="fieldsControl._switchColumnMode('` + this.fieldAccuracy + `');" style="aspect-ratio: 1/1; height: 2rem; padding: 0; border-radius: 5px !important; width: 2rem; margin-left: 0.5rem; justify-self: center; align-self: center;"><i class="fal fa-list-alt" style="font-size:1rem;"></i></button>
                                                </div>
                                            </div>
                                            <span id="AccuracyFieldName-validation" class="field-error-message"></span>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">` + this._getEntityResource('AltitudeFieldName') + `</label>
                                            <div class="input-group" style="flex-wrap: nowrap;">
                                                <input id="` + this.fieldAltitude + `" type="text" class="form-control" style="display:none;">
                                                <div id="` + this.fieldAltitude + `-combo" class="form-control"></div>
                                                <div class="input-group-append" style="display: grid;">
                                                    <button class="btn btn-sm waves-effect waves-themed rounded-circle" type="button" id="button-` + this.fieldAltitude + `" onclick="fieldsControl._switchColumnMode('` + this.fieldAltitude + `');" style="aspect-ratio: 1/1; height: 2rem; padding: 0; border-radius: 5px !important; width: 2rem; margin-left: 0.5rem; justify-self: center; align-self: center;"><i class="fal fa-list-alt" style="font-size:1rem;"></i></button>
                                                </div>
                                            </div>
                                            <span id="AltitudeFieldName-validation" class="field-error-message"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>`;
        }

        return template;
    }

    _getSubtypeItemsTemplate(options, dataType) {
        let template = `<div class="form-row mb-4">`;
        template += `<label class="form-label col-sm-2 mb-3">` + this._getEntityResource('SubtypeItems') + `</label>`;

        options.forEach(option => {
            template += `<div class="col-sm-3 mb-3">
                            <div class="form-group">
                                <div option-type="` + option.type + `" class="subtype-option-choice" id="subtype-option-choice-` + option.id + `"></div>
                                <label class="form-label ml-2">` + option.name + `</label>
                            </div>
                        </div>`;
        });

        template += `<span id="DataSubType-validation" class="field-error-message"></span></div>`;
        template += `<div id="field-special-field-wrapper" style="display: none;">`;
        template += `</div>`;
        if (dataType == 'STRING' || dataType == 'INTEGER') {
            template += `<div id="field-foreign-key-wrapper" style="display: none;">
                            <div class="form-row">
                                <div class="col-sm-12 d-flex align-items-center pb-2 border-bottom mb-3 ">
                                    <h3 class="subheader-title ml-1 ml-lg-0 mt-2"style="font-size: 1rem;">` + this._getEntityResource('AdvancedSettings') + `</h3>
                                </div>
                            </div>
                            <div class="form-row mb-3">
                                <div class="col-sm-6 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">` + this._getEntityResource('FieldForeignKey') + `</label>
                                        <div class="col-sm-12 mb-3 d-flex p-0 m-0">
                                            <input type="number" id="` + this.fieldForeignKey + `" class="form-control" autocomplete="off"/>
                                            <div class="input-group-append" style="display: grid;" id="` + this.fieldForeignKey + `-navigator">
                                                <button title="` + this._getEntityResource('NavigateRefEntity') + `" class="btn btn-primary btn-sm waves-effect waves-themed rounded-circle" type="button" onclick="fieldsControl._openRefEntity('` + this.fieldForeignKey + `');" style="aspect-ratio: 1/1; height: 2rem; padding: 0; border-radius: 5px !important; width: 2rem; margin-left: 0.5rem; justify-self: center; align-self: center;"><i class="fal fa-external-link" style="font-size:1rem;"></i></button>
                                            </div>
                                        </div>
                                        <span id="IdEntityFK-validation" class="field-error-message"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="field-file-wrapper" style="display: none;">
                            <div class="form-row">
                                <div class="col-sm-12 d-flex align-items-center pb-2 border-bottom mb-3 ">
                                    <h3 class="subheader-title ml-1 ml-lg-0 mt-2"style="font-size: 1rem;">` + this._getEntityResource('AdvancedSettings') + `</h3>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-sm-6 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">` + this._getEntityResource('StoreFilePath') + `</label>
                                        <input type="text" id="` + this.fieldStoreFilePath + `" class="form-control" autocomplete="off"/>
                                        <span id="StoreFilePath-validation" class="field-error-message"></span>
                                    </div>
                                </div>
                                <div class="col-sm-6 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">` + this._getEntityResource('AcceptMimeType') + `</label>
                                        <input type="text" id="` + this.fieldAcceptMimeType + `" class="form-control" autocomplete="off"/>
                                        <span id="AcceptMimeType-validation" class="field-error-message"></span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-sm-6 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">` + this._getEntityResource('MaxFileSize') + `</label>
                                        <input type="number" id="` + this.fieldMaxFileSize + `" class="form-control" autocomplete="off"/>
                                        <span id="MaxFileSize-validation" class="field-error-message"></span>
                                    </div>
                                </div>
                                <div class="col-sm-6 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">` + this._getEntityResource('FileNameField') + `</label>
                                        <div class="input-group" style="flex-wrap: nowrap;">
                                            <input id="` + this.fieldFileName + `" type="text" class="form-control" style="display:none;">
                                            <div id="` + this.fieldFileName + `-combo" class="form-control"></div>
                                            <div class="input-group-append" style="display: grid;">
                                                <button class="btn btn-sm waves-effect waves-themed rounded-circle" type="button" id="button-` + this.fieldFileName + `" onclick="fieldsControl._switchColumnMode('` + this.fieldFileName + `');" style="aspect-ratio: 1/1; height: 2rem; padding: 0; border-radius: 5px !important; width: 2rem; margin-left: 0.5rem; justify-self: center; align-self: center;"><i class="fal fa-list-alt" style="font-size:1rem;"></i></button>
                                            </div>
                                        </div>
                                        <span id="FileNameFieldName-validation" class="field-error-message"></span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-row mb-3">
                                <div class="col-sm-6 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">` + this._getEntityResource('MimeTypeField') + `</label>
                                        <div class="input-group" style="flex-wrap: nowrap;">
                                            <input id="` + this.fieldMimeType + `" type="text" class="form-control" style="display:none;">
                                            <div id="` + this.fieldMimeType + `-combo" class="form-control"></div>
                                            <div class="input-group-append" style="display: grid;">
                                                <button class="btn btn-sm waves-effect waves-themed rounded-circle" type="button" id="button-` + this.fieldMimeType + `" onclick="fieldsControl._switchColumnMode('` + this.fieldMimeType + `');" style="aspect-ratio: 1/1; height: 2rem; padding: 0; border-radius: 5px !important; width: 2rem; margin-left: 0.5rem; justify-self: center; align-self: center;"><i class="fal fa-list-alt" style="font-size:1rem;"></i></button>
                                            </div>
                                        </div>
                                        <span id="MimeTypeFieldName-validation" class="field-error-message"></span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-row mb-3">
                                <div class="col-sm-6 mb-3">
                                    <div class="form-group">
                                        <div id="` + this.fieldGeolocated + `"></div>
                                        <label class="form-label ml-2">` + this._getEntityResource('Geolocated') + `</label>
                                        <span id="Geolocated-validation" class="field-error-message"></span>
                                    </div>
                                </div>
                            </div>
                            <div id="` + this.geolocatedFieldsItem + `">
                                <div class="form-row">
                                    <div class="col-sm-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">` + this._getEntityResource('CoordFieldName') + `</label>
                                            <div class="input-group" style="flex-wrap: nowrap;">
                                                <input id="` + this.fieldCoord + `" type="text" class="form-control" style="display:none;">
                                                <div id="` + this.fieldCoord + `-combo" class="form-control"></div>
                                                <div class="input-group-append" style="display: grid;">
                                                    <button class="btn btn-sm waves-effect waves-themed rounded-circle" type="button" id="button-` + this.fieldCoord + `" onclick="fieldsControl._switchColumnMode('` + this.fieldCoord + `');" style="aspect-ratio: 1/1; height: 2rem; padding: 0; border-radius: 5px !important; width: 2rem; margin-left: 0.5rem; justify-self: center; align-self: center;"><i class="fal fa-list-alt" style="font-size:1rem;"></i></button>
                                                </div>
                                            </div>
                                            <span id="CoordFieldName-validation" class="field-error-message"></span>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">` + this._getEntityResource('Srid') + `</label>
                                            <div id="` + this.fieldSrid + `" class="form-control"></div>
                                            <span id="Srid-validation" class="field-error-message"></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row mb-4">
                                    <div class="col-sm-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">` + this._getEntityResource('AccuracyFieldName') + `</label>
                                            <div class="input-group" style="flex-wrap: nowrap;">
                                                <input id="` + this.fieldAccuracy + `" type="text" class="form-control" style="display:none;">
                                                <div id="` + this.fieldAccuracy + `-combo" class="form-control"></div>
                                                <div class="input-group-append" style="display: grid;">
                                                    <button class="btn btn-sm waves-effect waves-themed rounded-circle" type="button" id="button-` + this.fieldAccuracy + `" onclick="fieldsControl._switchColumnMode('` + this.fieldAccuracy + `');" style="aspect-ratio: 1/1; height: 2rem; padding: 0; border-radius: 5px !important; width: 2rem; margin-left: 0.5rem; justify-self: center; align-self: center;"><i class="fal fa-list-alt" style="font-size:1rem;"></i></button>
                                                </div>
                                            </div>
                                            <span id="AccuracyFieldName-validation" class="field-error-message"></span>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">` + this._getEntityResource('AltitudeFieldName') + `</label>
                                            <div class="input-group" style="flex-wrap: nowrap;">
                                                <input id="` + this.fieldAltitude + `" type="text" class="form-control" style="display:none;">
                                                <div id="` + this.fieldAltitude + `-combo" class="form-control"></div>
                                                <div class="input-group-append" style="display: grid;">
                                                    <button class="btn btn-sm waves-effect waves-themed rounded-circle" type="button" id="button-` + this.fieldAltitude + `" onclick="fieldsControl._switchColumnMode('` + this.fieldAltitude + `');" style="aspect-ratio: 1/1; height: 2rem; padding: 0; border-radius: 5px !important; width: 2rem; margin-left: 0.5rem; justify-self: center; align-self: center;"><i class="fal fa-list-alt" style="font-size:1rem;"></i></button>
                                                </div>
                                            </div>
                                            <span id="AltitudeFieldName-validation" class="field-error-message"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>`;
        }

        return template;
    }

    /* RESOURCES */

    _getEntityResource(name) {
        if (this.entityLocalization[name] != null && this.entityLocalization[name].trim() != '') {
            return this.entityLocalization[name];
        }

        return name;
    }

    _getGeneralResource(name) {
        if (this.generalLocalization[name] != null && this.generalLocalization[name].trim() != '') {
            return this.generalLocalization[name];
        }

        return name;
    }
}